import http from '../utils/fetch';
export default {
    getCode(usercode,phone) {
        return http({
            url: '/api/swyl/v1/basic/bscUserInfo/getCode',
            method: 'post',
            params: {usercode,phone}
        });
    },
    comment(usercode,phone,code,password) {
        return http({
            url: '/api/swyl/v1/basic/bscUserInfo/updateData',
            method: 'post',
            params: {usercode,phone,code,password}
        });
    },
}